import 'css-chunk:src/app/components/FilterList/QuickFilters/styles.scss';export default {
  "wrapper": "_wrapper_rnsaw_1",
  "option": "_option_rnsaw_4",
  "countBadge": "_countBadge_rnsaw_7",
  "selected": "_selected_rnsaw_30"
};